const isDev = import.meta.env.DEV

/**
 * Domains `localhost`, `prev.za...` and `dev.za...` will always redirect API calls
 * to `localhost:8000` (i.e. development mode). All other domains will redirect to
 * self (i.e. hosted mode).
 *
 * @param devProtocol either 'http' or 'ws' (applied only to development mode connections)
 * @param devPort either '8000', '5251' or '7244' (applied only to development mode connections)
 */
function endpoints(devProtocol: 'http' | 'ws' | 'https', devPort: '8000' | '5251' | '7244'): string {
  // For development mode in Vite, we need to handle the dev server differently
  const hostname = window.location.hostname

  switch (hostname) {
    case 'localhost':
    case 'prev.za.datamodellingplatform.africa.pwc.com':
    case 'prev.za.datamodellingplatform.africa.pwcglb.com':
    case 'dev.za.datamodellingplatform.africa.pwc.com':
    case 'dev.za.datamodellingplatform.africa.pwcglb.com':
      return `${devProtocol}://localhost:${devPort}`
    // case "next.za.datamodellingplatform.africa.pwc.com":
    // case "stag.za.datamodellingplatform.africa.pwc.com":
    // case "za.datamodellingplatform.africa.pwc.com":
  }

  // In development, default to localhost if no hostname match
  if (isDev) {
    return `${devProtocol}://localhost:${devPort}`
  }

  // In production, use the current hostname
  return `https://${hostname}`
}

export const ENDPOINTS = {
  GRAPHQL: `${endpoints('http', '8000')}/graphql`,
  CC_GATEWAY: `${endpoints('http', '8000')}/catalog/handler`,
  CC_DOTNET: `${endpoints('https', '7244')}/rest/catalog/handler`,
  GRAPHQL_WS: `${endpoints('ws', '8000')}/graphql`,
  LANDING: `${endpoints('https', '7244')}/rest`,
  DOTNET: `${endpoints('https', '7244')}`,
}
